import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Outlet, createRootRouteWithContext, useRouterState } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import type { ReactNode } from 'react';
import type { RouteContext } from '../router';
import { NotFoundPage } from '../router/not-found';

export const Route = createRootRouteWithContext<RouteContext>()({
  staticData: {
    pageName: '',
  },
  component: RouteComponent,
  notFoundComponent: RootNotFound,
});

function RootLayout({ children }: { children: ReactNode }) {
  return (
    <>
      <main>{children}</main>
      <TanStackRouterDevtools />
      <ReactQueryDevtools position="right" />
    </>
  );
}

function RouteComponent() {
  return (
    <RootLayout>
      <Outlet />
    </RootLayout>
  );
}

// An unmatched URL renders the 404 page inside the layout through the outlet. A notFound() thrown from a beforeLoad
// marks the root match itself, and the router then renders this component in place of the layout.
function RootNotFound() {
  const replacesLayout = useRouterState({ select: (state) => state.matches[0]?.status === 'notFound' });

  if (replacesLayout) {
    return (
      <RootLayout>
        <NotFoundPage />
      </RootLayout>
    );
  }

  return <NotFoundPage />;
}

export type { RouteContext };
